module.exports = __webpack_public_path__ + "media/v2/components/Header/shared/Profile/bell-a983b7bcf1ccd4820e6d1e8819122711.svg";